var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button"},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('i',{class:_vm.icon,attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }